import type { NovoGrupoBaseBody, TipoObraBase } from "@/modules/financeiro-configuracoes";
import {
  CODIGOS_COM_GRUPO,
  CODIGOS_DOCAGEM,
  CODIGO_PARADA,
  NOME_MAXIMO,
  NOME_OBRIGATORIO,
  TIPOS_OBRIGATORIO,
} from "./novo-grupo-dialog.constants";

export type NovoGrupoForm = {
  nome: string;
  tiposObraIds: string[];
};

export const NOVO_GRUPO_VAZIO: NovoGrupoForm = { nome: "", tiposObraIds: [] };

export const tiposElegiveis = (tipos: readonly TipoObraBase[]) =>
  tipos.filter((tipo) => tipo.situacao === "ATIVO" && CODIGOS_COM_GRUPO.includes(tipo.codigo));

export const codigosMarcados = (tipos: readonly TipoObraBase[], marcados: readonly string[]) =>
  tipos.filter((tipo) => marcados.includes(tipo.id)).map((tipo) => tipo.codigo);

export const marcou103 = (tipos: readonly TipoObraBase[], marcados: readonly string[]) =>
  codigosMarcados(tipos, marcados).includes(CODIGO_PARADA);

export function tipoTravado(
  tipo: TipoObraBase,
  tipos: readonly TipoObraBase[],
  marcados: readonly string[],
): boolean {
  if (marcados.includes(tipo.id)) return false;
  const codigos = codigosMarcados(tipos, marcados);
  if (tipo.codigo === CODIGO_PARADA) return CODIGOS_DOCAGEM.some((c) => codigos.includes(c));
  return codigos.includes(CODIGO_PARADA);
}

export const erroNome = (nome: string) => {
  if (!nome.trim()) return NOME_OBRIGATORIO;
  return nome.trim().length > NOME_MAXIMO ? `Use até ${NOME_MAXIMO} caracteres` : null;
};

export const erroTipos = (tiposObraIds: readonly string[]) =>
  tiposObraIds.length > 0 ? null : TIPOS_OBRIGATORIO;

export const montarCorpo = ({ nome, tiposObraIds }: NovoGrupoForm): NovoGrupoBaseBody => ({
  nome: nome.trim(),
  tiposObraIds,
});
